import { Injectable } from '@angular/core';

import { ResourceBaseUrlBuilder } from './api/resource-base-url-builder';
import { IssuingQuery } from './issuing/issuing.query';
import { UserNamespacedResourceBaseUrlBuilder } from './user-namespaced-resource-base-url-builder.service';
import { standardizeUrl } from './utils';

/**
 * Builds the following backend URLs:
 *   - emittents/{emittent_uid}/issuings/{issuing_uid}
 *   - investors/{investor_uid}/issuings/{issuing_uid}
 */
@Injectable({ providedIn: 'root' })
export class IssuingNamespacedResourceBaseUrlBuilder implements ResourceBaseUrlBuilder {
  constructor(private issuingQuery: IssuingQuery, private userNamespaceBuilder: UserNamespacedResourceBaseUrlBuilder) {}

  public buildBaseUrl(append?: string): string {
    const userNamespace = this.userNamespaceBuilder.buildBaseUrl();
    const issuingId = this.issuingQuery.getActiveId();
    let url = `${userNamespace}/issuings/${issuingId}`;

    if (append) {
      url += `/${append}`;
    }

    return standardizeUrl(url);
  }
}
